<template>
	<v-sheet color="transparent">
		<h2 class="cn-font">
			{{collaboration.name}}
		</h2>
		<v-row>
			<v-col cols="12" sm="4">
				<CollaborationOverview :id="id"></CollaborationOverview>
			</v-col>
			<v-col cols="12" sm="8" class="pt-1">
				<v-row>
					<v-col>
						<v-card>
							<v-card-text>								
								<CollaborationStats :id="collaboration.id"></CollaborationStats>
							</v-card-text>
						</v-card>
						
					</v-col>
				</v-row>
					<v-row>
						<v-col>
							<v-card>
								<v-card-text>
									<CollaborationParticipants :id="collaboration.id"></CollaborationParticipants>				
								</v-card-text>
							</v-card>
						</v-col>
					</v-row>
				<h3 class="cn-font grey--text">
					<v-row>
						<v-col>
							Überblick verfügbare Beiträge
							<v-card>
								<v-card-text></v-card-text>
								<CollaborationResponses></CollaborationResponses>
							</v-card>
						</v-col>
					</v-row>
				</h3>
			</v-col>
		</v-row>
		<p>
			<BackButton></BackButton>
		</p>
	</v-sheet>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import CollaborationOverview from "@/components/assessment/collaborations/CollaborationOverview";
	import CollaborationParticipants from "@/components/assessment/collaborations/CollaborationParticipants";
	import CollaborationStats from "@/components/assessment/collaborations/CollaborationStats";
	import BackButton from "@/components/elements/BackButton";
	import CollaborationResponses from "@/components/assessment/collaborations/CollaborationResponses"
	export default {
		name: "Collaboration", 
		props: {
			id: {type: String}
		},
		data: () => {
			return {
			}
		},
		components: {
			BackButton,
			CollaborationOverview,
			CollaborationParticipants,
			CollaborationStats,
			CollaborationResponses
		},
		computed: {
			...Vuex.mapState({
				collaborations: state => state.collaborations || []
			}),
			collaboration(){
				var id = this.id;
				return this.collaborations.find( c => c.id == id )
			}
		},
		// methods: {
		// }
		// created(){
			
		// }

	}
</script>